module.exports = __webpack_public_path__ + "img/gem.d0750fb8.png";